import { useFetch } from "src/hooks/useFetch";
import { ExtensionDetails } from "src/types";
import { ExtensionsService } from "src/services";

const useGetExtensionDetails = () => {
  const [
    extensionDetailsState,
    fetchExtensionDetails,
    abortExtensionDetailsFetch,
  ] = useFetch<ExtensionDetails>();

  const handleFetchExtensionDetails = (id: string) => {
    fetchExtensionDetails((signal) => ExtensionsService.getDetails(id, signal));
  };

  const initializeExtensionDetailsFetch = (id: string) => {
    abortExtensionDetailsFetch();
    handleFetchExtensionDetails(id);
  };

  return [extensionDetailsState, initializeExtensionDetailsFetch] as const;
};

export default useGetExtensionDetails;
